import { AxiosInstance } from "axios";
import { ApiTableState } from "../types/ApiTable/ApiTableState";
import { Pagination } from "../types/PaginiationResult";
import { Organisation } from "../types/UserAdmin/Organisation";
import { UserDetails } from "../types/UserAdmin/UserDetails";
import { UserLight } from "../types/UserAdmin/UserLight";
import { UsersOverview } from "../types/UserAdmin/UsersOverview";

export default class UserAdminService {
  private _endpoint = "UserAdmin";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public listUsers(
    { sort, pagination, filterExpression }: ApiTableState,
    abortController?: AbortController,
  ): Promise<Pagination<UserDetails>> {
    const page = pagination.page;
    const pageSize = pagination.pageSize;

    const sortField = sort ? this.translateSortField(sort.field) : undefined;
    const sortExpression = sort ? `${sortField} ${sort?.direction}` : undefined;

    return this._client
      .get<any>(`${this._endpoint}`, {
        params: {
          page,
          pageSize,
          filterExpression,
          sortExpression,
        },
        signal: abortController?.signal,
      })
      .then((response) => {
        return response.data;
      });
  }

  public userOverview(): Promise<UsersOverview> {
    return this._client
      .get<any>(`${this._endpoint}/overview`)
      .then((response) => {
        return response.data;
      });
  }

  public searchUsers(searchText: string): Promise<UserLight[]> {
    return this._client
      .get<any>(`${this._endpoint}/SearchUsers/${searchText}`)
      .then((response) => {
        return response.data;
      });
  }

  public searchOrganisations(searchTerm: string): Promise<Organisation[]> {
    return this._client
      .get<any>(`${this._endpoint}/SearchOrganisations/${searchTerm}`)
      .then((response) => {
        return response.data;
      });
  }

  private translateSortField(sort: string): string {
    switch (sort) {
      case "registered":
        return "CreateDate";
      case "organisation":
        return "OrganisationName";
      default:
        return sort;
    }
  }
}
